import { render, staticRenderFns } from "./WordFrequency.vue?vue&type=template&id=f500d0e2&scoped=true&"
import script from "./WordFrequency.vue?vue&type=script&lang=js&"
export * from "./WordFrequency.vue?vue&type=script&lang=js&"
import style0 from "./WordFrequency.vue?vue&type=style&index=0&lang=less&"
import style1 from "./WordFrequency.vue?vue&type=style&index=1&id=f500d0e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f500d0e2",
  null
  
)

export default component.exports